import state from './moduleBookingChannelManagementState.js'
import mutations from './moduleBookingChannelManagementMutations.js'
import actions from './moduleBookingChannelManagementActions.js'
import getters from './moduleBookingChannelManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

